"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membersRepository = void 0;
const utils_1 = require("@hc-frontend/utils");
const membersRepository = {
    getMembers() {
        return (0, utils_1.loadObject)("hc/members" /* Members */);
    },
    saveMembers(members) {
        (0, utils_1.saveObject)("hc/members" /* Members */, members);
    },
};
exports.membersRepository = membersRepository;
//# sourceMappingURL=members-repository.js.map